import React from 'react';

const AdminUsersRoles: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">角色管理</h1>
      <p className="text-gray-600">此页面为占位页，后续将提供系统角色的管理与配置。</p>
    </div>
  );
};

export default AdminUsersRoles;


